import {ModuleProto} from "../module-proto";
import {ModuleType} from "../types";
import {SettingsMenuTopCategory} from "../settings-module";
import {SettingsParentSection} from "../../../app/settings/const";

// const debug = "OfficesModule"
const debug = false

export class OfficesModule extends ModuleProto {

    constructor(moduleConfig: JSONObject) {
        super(ModuleType.OFFICES, moduleConfig);

        debug && console.log(debug, "constructor() moduleConfig=", moduleConfig)

        this.name                       = "Offices"

        this.description                = "The Clock In/Out module provides a streamlined solution for tracking work hours and attendance. Users can easily clock in and out directly within the platform, allowing for accurate records of their working hours. "
        this.svgIcon                    = "isvg-offices"
        this.settingsMenuTopCategory    = SettingsMenuTopCategory.ORGANIZATION
        this.typeLabel                  = "Organization account"
        this.settingsUrl                = "settings/offices"

        this.canDisable                 = false
        this._isEnabled                 = true // because this.canDisable false

        this.parentSection              = SettingsParentSection.ORGANIZATION

    }



    toJson() {
        const result = super.toJson();

        return result
    }

}
